import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Workflow } from 'lucide-react';
import { Skeleton } from '@wit-support/ui';
import { createModulePerms } from '@wit-support/ui-domain';
import { preloadElk } from './graph/layout-elk.js';
import { PipelinesListPage } from './routes/list.js';
// NB: no public `usePipelinesPerms` re-export — the previous one had zero
// consumers anywhere in the repo (see M-023); this context is consumed only
// by `PipelinesPageRoute` below.
const { Provider: PipelinesModulePermsProvider, usePerms: usePipelinesPerms } = createModulePerms({ canManage: false });
export { PipelinesModulePermsProvider };
function PipelinesPageRoute() {
    const { canManage } = usePipelinesPerms();
    return _jsx(PipelinesListPage, { canManage: canManage });
}
/**
 * The editor (React Flow, the inspector forms, the HTML editor) is the heavy
 * part of the module: loaded on demand so the list and the rest of the admin do
 * not grow (spec §4.1). Never re-export `routes/editor` statically from this
 * file — a static import puts it back into the main chunk.
 */
const LazyPipelineEditorPage = lazy(() => {
    // The layout engine (ELK, its own lazy chunk) starts loading together with
    // the editor's chunk — in parallel with it and with the pipeline request —
    // not only after the editor has rendered and asked for the first layout.
    preloadElk();
    return import('./routes/editor.js').then((m) => ({ default: m.PipelineEditorPage }));
});
function PipelineEditorRoute() {
    const { canManage } = usePipelinesPerms();
    return (_jsx(Suspense, { fallback: _jsxs("div", { className: "flex h-full flex-col gap-3 p-4", "aria-busy": "true", children: [_jsx(Skeleton, { className: "h-10 w-full" }), _jsx(Skeleton, { className: "min-h-0 w-full flex-1" })] }), children: _jsx(LazyPipelineEditorPage, { canManage: canManage }) }));
}
export const pipelinesModule = {
    id: 'pipelines',
    label: 'Пайплайны',
    icon: Workflow,
    permission: 'pipelines.read',
    workspace: 'support',
    order: 55,
    description: 'Автоматические сценарии (условия и действия) и их запуски.',
    // `/new` is declared before `/$pipelineId`; the router ranks the static
    // segment higher anyway, so `/pipelines/new` never opens a pipeline «new».
    routes: [
        { path: '/', component: PipelinesPageRoute },
        // The editor is a workspace (toolbar, palette, canvas, inspector): the
        // shell gives it the whole area under its header, the panels scroll.
        {
            path: '/new',
            component: PipelineEditorRoute,
            label: 'Новый пайплайн',
            layout: 'fullscreen',
        },
        {
            path: '/$pipelineId',
            component: PipelineEditorRoute,
            label: 'Пайплайн',
            layout: 'fullscreen',
        },
    ],
};
export { PipelinesListPage } from './routes/list.js';
export { setPipelinesApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map